import { createAction } from 'redux-actions';
import { createActions } from 'redux-actions';
import {
  createAsyncActions,
  runAsyncWorkflow
} from '../lib/reduxHelpers';

import { Book, MobileTranslate } from '../api';


export const [
  fetchBook,
  receiveBook,
  fetchBookError
] = createAsyncActions(
  'BOOK',
  slug => ({ slug }),
  ({ data }) => ({ book: data })
);

export const fetchBookWorkflow = (slug , isCsf=false )=> {
  const fetchPromise = Book.fetch(slug , isCsf);

  return runAsyncWorkflow({
      fetch: fetchBook,
      receive: receiveBook,
      error: fetchBookError
    },
    fetchPromise,
    undefined,
    undefined,
    (dispatchFn, error) => {},
    true);
};

export const [
  fetchExtendedBook,
  receiveExtendedBook,
  fetchExtendedBookError
] = createAsyncActions(
  'BOOK_EXTENDED',
  id => ({ id }),
  ({ data}) => ({ data })
);

export const fetchExtendedBookWorkflow = (id)=> {
  const fetchPromise = Book.fetchExtendedBook(id);

  return runAsyncWorkflow({
      fetch: fetchExtendedBook,
      receive: receiveExtendedBook,
      error: fetchExtendedBookError
    },
    fetchPromise,
    undefined,
    undefined,
    (dispatchFn, error) => {},
    true);
};

export const [
  fetchBookDownloadLimit,
  receiveBookDownloadLimit,
  fetchBookDownloadLimitError
] = createAsyncActions(
  'BOOK_DOWNLOAD_LIMIT',
  slug => ({ slug }),
  ({ data }) => ({ book: data })
);

export const fetchBookDownloadLimitWorkflow = slug => {
  const fetchPromise = Book.fetch(slug);

  return runAsyncWorkflow({
    fetch: fetchBookDownloadLimit,
    receive: receiveBookDownloadLimit,
    error: fetchBookDownloadLimitError
  }, fetchPromise);
};

export const [
  fetchNextReadBooks,
  receiveNextReadBooks,
  fetchNextReadBooksError
] = createAsyncActions(
  'NEXT_READ_BOOKS',
  slug => (slug),
  ({ data }) => ({ nextReadBooks: data.similarBooks })
);

export const fetchNextReadBooksWorkflow = slug => {
  const fetchPromise = Book.fetchSimilarBooks(slug);

  return runAsyncWorkflow({
    fetch: fetchNextReadBooks,
    receive: receiveNextReadBooks,
    error: fetchNextReadBooksError
  }, fetchPromise,
  { slug });
};

export const [
  getBookshelfList,
  receiveGetBookshelfList,
  getBookshelfListError
] = createAsyncActions(
  'GET_BOOKSHELF_LIST',
  () => {},
  ({data}) => ({data})
);

export const getBookshelfListWorkflow = () => {
  const fetchPromise = Book.getBookShelfList();

  return runAsyncWorkflow(
    {
      fetch: getBookshelfList,
      receive: receiveGetBookshelfList,
      error: getBookshelfListError
    }, fetchPromise);
};

export const [
  addBookshelf,
  receiveAddBookshelf,
  addBookshelfError
] = createAsyncActions(
  'ADD_BOOKSHELF',
  ({title, storyId}) => ({title, storyId}),
  ({data}) => ({lists: data})
);

export const addBookshelfWorkflow = (title, storyId) => {
  const fetchPromise = Book.addBookShelf(title, storyId);
  return runAsyncWorkflow(
  {
    fetch: addBookshelf,
    receive: receiveAddBookshelf,
    error: addBookshelfError
  }, 
  fetchPromise,
  {title, storyId})
}

export const [
  addNewBookToBookshelf,
  receiveAddNewBookToBookshelf,
  addNewBookToBookshelfError
] = createAsyncActions(
  'ADD_NEW_BOOK_TO_BOOKSHELF',
  ({bookshelfId, storyId}) => ({bookshelfId, storyId}),
  ({data}) => ({lists: data})
);

export const addNewBookToBookshelfWorkflow = (bookshelfId, storyId) => {
  const fetchPromise = Book.addBookToBookshelf(bookshelfId, storyId);
  return runAsyncWorkflow(
  {
    fetch: addNewBookToBookshelf,
    receive: receiveAddNewBookToBookshelf,
    error: addNewBookToBookshelfError
  }, 
  fetchPromise,
  { bookshelfId, storyId }
  );
}

export const [
  getBookshelfAutocomplete,
  receiveGetBookshelfAutocomplete,
  getBookshelfAutocompleteError
] = createAsyncActions(
  'GET_BOOKSHELF_AUTOCOMPLETE',
  ({str}) => ({str}),
  ({data}) => ({data})
);

export const getBookshelfAutocompletefWorkflow = (str) => {
  const fetchPromise = Book.getBookshelfAutocomplete(str);
  return runAsyncWorkflow(
  {
    fetch: getBookshelfAutocomplete,
    receive: receiveGetBookshelfAutocomplete,
    error: getBookshelfAutocompleteError
  }, fetchPromise)
}

export const [
  removeFromBookshelf,
  receiveRemoveFromBookshelf,
  removeFromBookshelfError
] = createAsyncActions(
  'REMOVE_BOOK_FROM_BOOKSHELF',
  ({ bookSlug, listSlug }) => ({ bookSlug, listSlug }),
  ({ data }) => ({lists: data})
);

export const removeBookFromBookshelfWorkflow = (bookSlug, listSlug) => {
  const fetchPromise = Book.removeFromList(bookSlug, listSlug);

  return runAsyncWorkflow(
    {
      fetch: removeFromBookshelf,
      receive: receiveRemoveFromBookshelf,
      error: removeFromBookshelfError
    },
    fetchPromise,
    { bookSlug, listSlug }
  );
};


export const [
  postFlagBook,
  receivePostFlagBook,
  postFlagBookError
] = createAsyncActions(
  'FLAG_BOOK',
  ({ bookSlug, reasons }) => ({ bookSlug, reasons }),
  ({ bookSlug }) => ({ bookSlug })
);

export const postFlagBookWorkflow = (bookSlug, reasons) => {
  const fetchPromise = Book.flag(bookSlug, reasons);

  return runAsyncWorkflow(
    {
      fetch: postFlagBook,
      receive: receivePostFlagBook,
      error: postFlagBookError
    },
    fetchPromise,
    { bookSlug, reasons }
  );
};

export const [
  postSuggestion,
  receivePostSuggestion,
  postSuggestionError
] = createAsyncActions(
  'SUGGESTION',
  ({ page_number , suggestion , selection_text , story_id , updated_page_content , suggestion_id }) => ({ page_number , suggestion , selection_text , story_id , updated_page_content , suggestion_id }),
  ({ page_number , suggestion , selection_text  , story_id , updated_page_content , suggestion_id }) => ({ page_number , suggestion , selection_text ,story_id , updated_page_content , suggestion_id })
);

export const postSuggestionWorkflow = (postSuggestPayload) => {
  const fetchPromise = Book.submitSuggestion(postSuggestPayload);

  return runAsyncWorkflow(
    {
      fetch: postSuggestion,
      receive: receivePostSuggestion,
      error: postSuggestionError
    },
    fetchPromise,
    postSuggestPayload
    );
};

export const [
  postEditBook,
  receivePostEditBook,
  postEditBookError
] = createAsyncActions(
  'EDIT_BOOK',
  ({ bookSlug, name , reason }) => ({ bookSlug, name , reason }),
  ({ bookSlug }) => ({ bookSlug })
);

export const postEditBookWorkflow = (bookSlug, name, reason) => {
  const fetchPromise = Book.editBook(bookSlug, name ,reason);

  return runAsyncWorkflow(
    {
      fetch: postEditBook ,
      receive: receivePostEditBook,
      error: postEditBookError
    },
    fetchPromise,
    { bookSlug, name , reason }
  );
};

export const [
  fetchSuggestions,
  receiveSuggestions,
  fetchSuggestionsError
] = createAsyncActions(
  'FETCH_SUGGESTIONS',
  query => ({ query  }),
  ({ data }) => ({ suggestions : data.suggestions })
);

export const fetchSuggestionsWorkflow = (query) => {
  const fetchPromise = Book.fetchSuggestions(query);

  return runAsyncWorkflow({
    fetch: fetchSuggestions,
    receive: receiveSuggestions,
    error: fetchSuggestionsError
  }, fetchPromise);
};

export const { updatePageContent ,resetSuggestions ,updateReviewerSuggestions } = createActions({
  'UPDATE_PAGE_CONTENT': (updatedContent , pageId ) => ({ updatedContent , pageId  }),
  'RESET_SUGGESTIONS': () => ({}),
  'UPDATE_REVIEWER_SUGGESTIONS' : (suggestionId) => ({ suggestionId})
})

export const [
  blockUser,
  receiveBlockUser,
  blockUserError
] = createAsyncActions(
  'BLOCK_USER',
  ({ user_id }) => ({ user_id }),
  ({ user_id }) => ({ user_id }),
  'PUT'
);

export const blockUserWorkflow = (user_id) => {
  const fetchPromise = Book.blockUser(user_id);

  return runAsyncWorkflow(
    {
      fetch: blockUser,
      receive: receiveBlockUser,
      error: blockUserError
    }, 
    fetchPromise,
    {user_id }
  );
};

export const [
  resolveSuggestions,
  receiveResolveSuggestions,
  resolveSuggestionsError
] = createAsyncActions(
  'RESOLVE_SUGGESTIONS',
  ({ suggestion_id , page_content  }) => ({ suggestion_id , page_content }),
  ({ suggestion_id , page_content  }) => ( { suggestion_id , page_content }),
  'PUT' 
);

export const resolveSuggestionsWorkflow = (suggestion_id , page_content) => {
  const fetchPromise = Book.resolveSuggestions(suggestion_id , page_content);

  return runAsyncWorkflow(
    {
      fetch: resolveSuggestions,
      receive: receiveResolveSuggestions,
      error: resolveSuggestionsError
    }, 
    fetchPromise,
    { suggestion_id , page_content }
  );
};


export const [
  blockStory,
  receiveBlockStory,
  blockStoryError
] = createAsyncActions(
  'BLOCK_STORY',
  ({ story_id }) => ({ story_id }),
  ({ story_id }) => ({ story_id }),
  'PUT'
);

export const blockStoryWorkflow = (story_id) => {
  const fetchPromise = Book.blockStory(story_id);

  return runAsyncWorkflow(
    {
      fetch: blockStory,
      receive: receiveBlockStory,
      error: blockStoryError
    }, 
    fetchPromise,
    { story_id }
  );
};


export const [
  postSmileyRating,
  receivePostSmileyRating,
  postSmileyRatingError
] = createAsyncActions(
  'SMILEY_RATING',
  ({ bookSlug, reaction }) => ({ bookSlug, reaction }),
  ({ bookSlug }) => ({ bookSlug })
);

export const postSmileyRatingWorkflow = (bookSlug, reaction) => {
  const fetchPromise = Book.submitSmileyRating(bookSlug, reaction);

  return runAsyncWorkflow(
    {
      fetch: postSmileyRating,
      receive: receivePostSmileyRating,
      error: postSmileyRatingError
    },
    fetchPromise,
    { bookSlug, reaction }
  );
};

export const [
  fetchSmileyRatingBook,
  receiveSmileyRatingBook,
  fetchSmileyRatingBookError
] = createAsyncActions(
  'SMILEY_RATING_BOOKS',
  slug => ({ slug }),
  ({ data }) => ({ smileyRatingBook: data })
);

export const fetchSmileyRatingBookWorkflow = slug => {
  const fetchPromise = Book.fetch(slug);

  return runAsyncWorkflow({
    fetch: fetchSmileyRatingBook,
    receive: receiveSmileyRatingBook,
    error: fetchSmileyRatingBookError
  }, fetchPromise);
};

export const [
  fetchNextTranslationBooks,
  receiveNextTranslationBooks,
  fetchNextTranslationBooksError
] = createAsyncActions(
  'NEXT_TRANSLATION_BOOKS',
  ({slug , translateToLanguage })=> ({ slug , translateToLanguage }),
  ({ data }) => ({ nextTranslationBooks: data.similarBooks })
);

export const [
  postTranslationEditorFeedback,
  receivePostTranslationEditorFeedback,
  postTranslationEditorFeedbackError
] = createAsyncActions(
  'POST_TRANSLATION_EDITOR_RATING',
  ({ selectedReasons, rating }) => ({ selectedReasons, rating })
);

export const postTranslationEditorFeedbackWorkflow = (selectedReasons, rating) => {
  const fetchPromise = Book.submitTranslationEditorFeedback(selectedReasons, rating);

  return runAsyncWorkflow(
    {
      fetch: postTranslationEditorFeedback,
      receive: receivePostTranslationEditorFeedback,
      error: postTranslationEditorFeedbackError
    },
    fetchPromise,
    { selectedReasons, rating }
  );
};


export const fetchNextTranslationBooksWorkflow = (slug , translateToLanguage) => {
  const fetchPromise = Book.fetchNextTranslationBooks(slug, translateToLanguage);

  return runAsyncWorkflow({
    fetch: fetchNextTranslationBooks,
    receive: receiveNextTranslationBooks,
    error: fetchNextTranslationBooksError
  }, fetchPromise);
};

export const [
  postRelevel,
  receivePostRelevel,
  postRelevelError
] = createAsyncActions(
  'RELEVEL',
  ({ bookSlug, newLevel }) => ({ bookSlug, newLevel }),
  ({ newLevel }) => ({ newLevel })
);

export const postRelevelWorkflow = (bookSlug, newLevel) => {
  const fetchPromise = Book.relevel(bookSlug, newLevel);

  return runAsyncWorkflow(
    {
      fetch: postRelevel,
      receive: receivePostRelevel,
      error: postRelevelError
    },
    fetchPromise,
    { bookSlug, newLevel }
  );
};

export const [
  postAddAward,
  receivePostAddAward,
  postAddAwardError
] = createAsyncActions(
  'ADD_AWARD',
  ({ bookSlug, awardDescription  }) => ({ bookSlug, awardDescription }),
  ({ awardDescription }) => ({ awardDescription })
);

export const postAddAwardWorkflow = (bookSlug, awardDescription ) => {
  const fetchPromise = Book.addAward(bookSlug, awardDescription );

  return runAsyncWorkflow(
    {
      fetch: postAddAward,
      receive: receivePostAddAward,
      error: postAddAwardError
    },
    fetchPromise,
    { bookSlug, awardDescription }
  );
};

export const [
  postChangeLanguage,
  receiveChangeLanguage,
  postChangeLanguageError
] = createAsyncActions(
  'CHANGE_LANGUAGE',
  ({ bookSlug, newLanguage }) => ({ bookSlug, newLanguage }),
  ({ newLanguage }) => ({ newLanguage })
);

export const postChangedLanguageWorkflow = (bookSlug, newLanguage) => {
  const fetchPromise = Book.updateLanguage(bookSlug, newLanguage);

  return runAsyncWorkflow(
    {
      fetch: postChangeLanguage,
      receive: receiveChangeLanguage,
      error: postChangeLanguageError
    },
    fetchPromise,
    { bookSlug, newLanguage }
  );
};

export const [
  updateAward,
  receiveUpdateAward,
  updateAwardError
] = createAsyncActions(
  'EDIT_AWARD',
  ({ bookSlug, awardDescription , awardId  }) => ({ bookSlug, awardDescription , awardId}),
  ({ awardDescription , awardId }) => ({ awardDescription , awardId}),
  'PUT'
);

export const updateAwardWorkflow = (bookSlug, awardDescription , awardId) => {
  const fetchPromise = Book.updateAward(bookSlug, awardDescription , awardId);

  return runAsyncWorkflow(
    {
      fetch: updateAward,
      receive: receiveUpdateAward,
      error: updateAwardError
    }, 
    fetchPromise,
    { bookSlug, awardDescription , awardId }
  );
};

export const [
  postGatingFormData,
  receivePostGatingFormData,
  postGatingFormDataError
] = createAsyncActions(
  'GATING_FORM',
  ({ user_type , download_reasons ,children_count, schools_count , updated_organisation,feedback_type }) => ({ user_type , download_reasons ,children_count, schools_count, updated_organisation,feedback_type  }),
  ({ user_type , download_reasons ,children_count, schools_count , updated_organisation,feedback_type }) => ({ user_type , download_reasons ,children_count, schools_count, updated_organisation, feedback_type })
);

export const postGatingFormDataWorkflow = (postGatingFormPayload) => {
  const fetchPromise = Book.submitGatingForm(postGatingFormPayload);

  return runAsyncWorkflow(
    {
      fetch: postGatingFormData,
      receive: receivePostGatingFormData,
      error:  postGatingFormDataError
    },
    fetchPromise,
    postGatingFormPayload
  );
};

export const [
  postImageGatingFormData,
  receivePostImageGatingFormData,
  postImageGatingFormDataError
] = createAsyncActions(
  'IMAGE_GATING_FORM',
  () => {},
  () => {}
);

export const postImageGatingFormDataWorkflow = (postGatingFormPayload) => {
  const fetchPromise = Book.submitImgGatingForm(postGatingFormPayload);

  return runAsyncWorkflow(
    {
      fetch: postImageGatingFormData,
      receive: receivePostImageGatingFormData,
      error: postImageGatingFormDataError
    },
    fetchPromise,
    postGatingFormPayload
  );
};

export const [
  postOfflineTranslateData,
  receivePostOfflineTranslateData,
  postOfflineTranslateDataError
] = createAsyncActions(
  'OFFLINE_TRANSLATE',
  ({story_id , language_id , pageIds , pageTranslateContent}) => ({ story_id ,language_id ,pageIds , pageTranslateContent}),
  ({story_id , language_id,  pageIds , pageTranslateContent}) => ({ story_id ,language_id,pageIds , pageTranslateContent})
);

  export const postOfflineTranslateDataWorkflow = (bookId, language, postOfflineTranslatePayload) => {
  const fetchPromise = Book.submitOfflineTranslateData(bookId, language, postOfflineTranslatePayload);

  return runAsyncWorkflow(
    {
      fetch: postOfflineTranslateData,
      receive: receivePostOfflineTranslateData,
      error: postOfflineTranslateDataError
    },
    fetchPromise,
    postOfflineTranslatePayload
  );
};

export const [
  fetchBookAssets,
  receiveBookAssets,
  receiveBookAssetsError
] = createAsyncActions(
  'BOOK_ASSETS',
  ({ slug }) => ({ slug }),
  ({ data }) => ({ assets: data })
);

export const fetchBookAssetsWorkflow = (slug, isAudio = false, ignoreCount = false , isCsf=false, isFlpHome=false, isStem=false ,org_id=false, embed=false) => {
  const fetchPromise = Book.fetchAssets(slug, isAudio, ignoreCount , isCsf, isFlpHome, isStem, org_id, embed);

  return runAsyncWorkflow(
    {
      fetch: fetchBookAssets,
      receive: receiveBookAssets,
      error: fetchBookError
    },
    fetchPromise,
    { slug }
  );
};

export const [
  fetchBookAssetsForMobileTranslate,
  receiveBookAssetsForMobileTranslate,
  receiveBookAssetsForMobileTranslateError
] = createAsyncActions(
  'BOOK_ASSETS_FOR_MOBILE_TRANSLATE',
  ({ slug }) => ({ slug }),
  ({ data }) => ({ assets: data })
);

export const fetchBookAssetsForMobileTranslateWorkflow = (slug, ignoreCount = true) => {
  const fetchPromise = MobileTranslate.fetchAssetsForMobileTranslte(slug, ignoreCount);

  return runAsyncWorkflow(
    {
      fetch: fetchBookAssetsForMobileTranslate,
      receive: receiveBookAssetsForMobileTranslate,
      error: receiveBookAssetsForMobileTranslateError
    },
    fetchPromise,
    { slug }
  );
};

export const [
  fetchAssetsForOfflineTranslate,
  receiveAssetsForOfflineTranslate,
  receiveAssetsForOfflineTranslateError
] = createAsyncActions(
  'BOOK_ASSETS_FOR_OFFLINE_TRANSLATE',
  ({ slug }) => ({ slug }),
  ({ data }) => ({ assetsForOfflineTranslate: data })
);

export const fetchAssetsForOfflineTranslateWorkflow = (slug) => {
  const fetchPromise = Book.fetchAssetsForOfflineTranslate(slug);

  return runAsyncWorkflow(
    {
      fetch: fetchAssetsForOfflineTranslate,
      receive: receiveAssetsForOfflineTranslate,
      error: fetchBookError
    },
    fetchPromise,
    { slug }
  );
};

export const [
  addToEditorsPicks,
  receiveAddToEditorsPicks,
  addToEditorsPicksError
] = createAsyncActions(
  'ADD_TO_EDITORS_PICKS',
  ({ slug }) => ({ slug })
);

export const addToEditorsPicksWorkflow = (slug) => {
  const addToEditorsPicksPromise = Book.addToEditorsPicks(slug);

  return runAsyncWorkflow(
    {
      fetch: addToEditorsPicks,
      receive: receiveAddToEditorsPicks,
      error: addToEditorsPicksError
    },
    addToEditorsPicksPromise
  );
};


export const [
  removeFromEditorsPicks,
  receiveRemoveFromEditorsPicks,
  removeFromEditorsPicksError
] = createAsyncActions(
  'REMOVE_FROM_EDITORS_PICKS',
  ({ slug }) => ({ slug })
);

export const removeFromEditorsPicksWorkflow = (slug) => {
  const removeFromEditorsPicksPromise = Book.removeFromEditorsPicks(slug);

  return runAsyncWorkflow(
    {
      fetch: removeFromEditorsPicks,
      receive: receiveRemoveFromEditorsPicks,
      error: removeFromEditorsPicksError
    },
    removeFromEditorsPicksPromise
  );
};


export const [
  likeBook,
  receiveLikeBook,
  likeBookError
] = createAsyncActions(
  'LIKE_BOOK',
  ({ slug }) => ({ slug })
);

export const likeBookWorkflow = (slug) => {
  const likeBookPromise = Book.like(slug);

  return runAsyncWorkflow(
    {
      fetch: likeBook,
      receive: receiveLikeBook,
      error: likeBookError
    },
    likeBookPromise
  );
};


export const openGlobalBookReader = createAction('sw/OPEN_GLOBAL_BOOK_READER');
export const closeGlobalBookReader = createAction('sw/CLOSE_GLOBAL_BOOK_READER');

export const openNextReadSuggestions = createAction('sw/OPEN_NEXT_READ_SUGGESTIONS');
export const closeNextReadSuggestions = createAction('sw/CLOSE_NEXT_READ_SUGGESTIONS');

export const openGlobalQuickView = createAction(
  'sw/OPEN_GLOBAL_QUICK_VIEW',
  (book, readSource, eventCategory, isSupplementary) => ({ book, readSource, eventCategory, isSupplementary })
);
export const closeGlobalQuickView = createAction('sw/CLOSE_GLOBAL_QUICK_VIEW');
export const userBlockedById = createAction('sw/USER_BLOCKED');

export const openOfflineTranslator = createAction('sw/OPEN_OFFLINE_TRANSLATOR');
export const closeOfflineTranslator = createAction('sw/CLOSE_OFFLINE_TRANSLATOR');

export const openVideoPlayer = createAction('sw/OPEN_VIDEO_PLAYER');
export const closeVideoPlayer = createAction('sw/CLOSE_VIDEO_PLAYER');

export const [
  postOfflineTranslationFeedback,
  receivePostOfflineTranslationFeedback,
  postOfflineTranslationFeedbackError
] = createAsyncActions(
  'OFFLINE_TRANSLATION_FEEDBACK',
  () => ({})
);

export const postOfflineTranslationFeedbackWorkflow = (postOfflineTranslationFeedbackPayload) => {
  const fetchPromise = Book.submitOfflineTranslationFeedback(postOfflineTranslationFeedbackPayload);

  return runAsyncWorkflow(
    {
      fetch: postOfflineTranslationFeedback,
      receive: receivePostOfflineTranslationFeedback,
      error: postOfflineTranslationFeedbackError
    },
    fetchPromise,
    postOfflineTranslationFeedbackPayload
  );
};



// WEBPACK FOOTER //
// ./src/redux/bookActions.js